import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DEFAULT_CHART_OPTIONS } from 'app/shared/helper/highchart-options';
import { cleanChart, getXDateFormat, updateChart } from 'app/shared/helper/highcharts.helper';
import { PreviewSerieType } from 'app/shared/models/data-studio.model';
import { DateTimeFormatService } from 'app/shared/services/date-time-format/date-time-format.service';
import Highcharts, { color, SeriesOptions } from 'highcharts';
import { delay } from 'rxjs/operators';

@Component({
    selector: 'app-preview-chart',
    templateUrl: './preview-chart.component.html',
    styleUrls: ['./preview-chart.component.scss'],
    standalone: false
})
export class PreviewChartComponent implements OnChanges {
  @Input() series: PreviewSerieType[] = null;
  @Input() unitsSelected: string[] | undefined = undefined;
  @Input() loading = false;

  chartOptions: Highcharts.Options;
  highcharts = Highcharts;
  chartRef: Highcharts.Chart;

  chartCallback: Highcharts.ChartCallbackFunction = (chart): void => {
    this.chartRef = chart;
  };

  constructor(
    private dateTimeFormatService: DateTimeFormatService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.series?.currentValue) {
      cleanChart(this.chartRef);
      this.setChartOptions();
      setTimeout(() => updateChart(this.chartRef, this.series.map(serie => ({
        ...serie,
        tooltip: {
          valueSuffix: ` ${serie.unit}`
        }
      }))), 100)
    }
  }

  private setChartOptions() {
    this.chartOptions = Highcharts.merge(DEFAULT_CHART_OPTIONS, {
      chart: {
        type: 'line',
        height: 450
      },
      plotOptions: {
        series: {
          marker: {
            enabled: false,
            symbol: 'circle',
          },
          animation: { duration: 0 },
          states: {
            hover: {
              enabled: true,
              halo: { size: 0 }
            },
            inactive: { enabled: false }
          }
        },
      },
      legend: {
        symbolHeight: 12,
        symbolWidth: 12,
        symbolRadius: 8
       },
      xAxis: {
        type: 'datetime',
        tickColor: 'var(--divider)',
        lineWidth: 0,
        gridLineWidth: 0,
        title: {
          text: ''
        },
        dateTimeLabelFormats: {
          day: `${getXDateFormat('dm', this.dateTimeFormatService)} ${getXDateFormat('t', this.dateTimeFormatService)}`,
          hour: `${getXDateFormat('dm', this.dateTimeFormatService)} ${getXDateFormat('t', this.dateTimeFormatService)}`
        },
        crosshair: {
          width: 3
        },
      },
      yAxis: [{
        type: 'linear',
        tickColor: 'var(--divider)',
        lineWidth: 1,
        lineColor: 'var(--divider)',
        gridLineWidth: 1,
        gridLineColor: 'var(--divider)',
        title: {
          text: this.unitsSelected[0],
        },
        labels: {
          formatter: function() {
            return this.value;
          }
        }
      }, {
        visible: this.unitsSelected.length > 1,
        opposite: true,
        title: {
          text: this.unitsSelected[1],
        },
        labels: {
          formatter: function() {
            return this.value;
          }
        }
      }],
      tooltip: {
        enabled: true,
        followPointer: true,
        hideDelay: 0,
        shared: true,
        animation: { duration: 0 },
        xDateFormat: `${getXDateFormat('dmy', this.dateTimeFormatService)} ${getXDateFormat('t', this.dateTimeFormatService)}`,
      },
      series: []
    });
  }

}